import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=57f8f1d6&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f8f1d6",
  null
  
)

export default component.exports